/**
 *
 * Create a string of HTML classes
 *
 * @name classnames
 * @function
 * @author Hannah Mahon <Hannah.Mahon@washpost.com>
 * @param {string} defaultClassNames default class names
 * @param {object} conditionalClassNames object of key value pairs where key is the classname and the value is the condition
 * @return {string} string of CSS classes
 * @example
 * <Component
 *  className={classnames("offblack mb-sm", {
 *    "brad-4": isMyConditionTrue
 *  })}
 * />
 *
 */
export const getClasses = (
  defaultClassNames = "",
  conditionalClassNames: object = {}
): string => {
  let classes = defaultClassNames;
  Object.entries(conditionalClassNames).forEach(([classname, shouldApply]) => {
    if (shouldApply) {
      classes += ` ${classname}`;
    }
  });

  return classes.trim();
};
